import React from 'react';
import './DesktopBlockedScreen.css';

const DesktopBlockedScreen = () => (
  <div className="desktop-blocked">
    <div className="desktop-blocked-icon">📱</div>
    <h2 className="desktop-blocked-title">Доступно лише з мобільного пристрою</h2>
    <p className="desktop-blocked-text">
      Цей застосунок розрахований на смартфон. Відкрийте цю сторінку з мобільного телефону, щоб продовжити.
    </p>
  </div>
);

export default DesktopBlockedScreen;
